import { useState } from 'react';

// Filters — the layered list editors only (show-only / hide / alerts).
// Quick-filter chips for bands / modes / continents live in the top toolbar
// to avoid duplicating that state across two surfaces.
export default function Filters({ settings, onUpdate }) {
  return (
    <div className="space-y-3">
      <ListEditor title="Show-only"
                  hint="Show only spots whose DX/spotter call starts with these prefixes."
                  entries={settings.showOnly}
                  enabled={settings.showOnlyOn}
                  onUpdate={(v) => onUpdate({ showOnly: v })}
                  onToggle={(b) => onUpdate({ showOnlyOn: b })} />
      <ListEditor title="Hide"
                  hint="Spots matching these are hidden (alerts override)."
                  entries={settings.hide}
                  enabled={settings.hideOn}
                  onUpdate={(v) => onUpdate({ hide: v })}
                  onToggle={(b) => onUpdate({ hideOn: b })} />
      <ListEditor title="Alerts"
                  hint="Highlight matches — overrides Hide, always shown."
                  entries={settings.alerts}
                  enabled={settings.alertsOn}
                  onUpdate={(v) => onUpdate({ alerts: v })}
                  onToggle={(b) => onUpdate({ alertsOn: b })}
                  highlight />
    </div>
  );
}

function ListEditor({ title, hint, entries, enabled, onUpdate, onToggle, highlight }) {
  const [draft, setDraft] = useState('');
  const add = () => {
    const v = draft.trim().toUpperCase();
    if (!v || entries.includes(v)) return;
    onUpdate([...entries, v]);
    setDraft('');
  };
  const remove = (e) => onUpdate(entries.filter((x) => x !== e));

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <h3 className={`text-xs uppercase tracking-wide ${
          highlight ? 'text-amber-400' : 'text-slate-400'}`}>
          {title}
        </h3>
        <label className="flex items-center gap-1 text-xs text-slate-400 cursor-pointer">
          <input type="checkbox" checked={enabled}
                 onChange={(e) => onToggle(e.target.checked)}
                 className="accent-cyan-500" />
          on
        </label>
      </div>
      <p className="text-[10px] text-slate-500 mb-1">{hint}</p>
      <div className="flex gap-1 mb-1">
        <input
          type="text"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && add()}
          placeholder="callsign or prefix"
          className="flex-1 bg-slate-800 px-2 py-1 rounded text-xs font-mono"
        />
        <button onClick={add}
                className="bg-slate-700 hover:bg-slate-600 px-2 py-1 rounded text-xs">+</button>
      </div>
      <div className="flex flex-wrap gap-1">
        {entries.map((e) => (
          <span key={e}
                className={`text-xs font-mono px-2 py-0.5 rounded-full flex items-center gap-1 ${
                  highlight ? 'bg-amber-500/30 text-amber-200' : 'bg-slate-700 text-slate-200'}`}>
            {e}
            <button onClick={() => remove(e)}
                    className="text-slate-500 hover:text-red-400 text-xs ml-1">×</button>
          </span>
        ))}
      </div>
    </div>
  );
}
